module.exports = "/_next/static/images/logo-snowbitch-9b7c690f6cef379caf83aca01b806c7a.png";